import { render, staticRenderFns } from "./HomeList.vue?vue&type=template&id=2b3b6996&scoped=true&"
import script from "./HomeList.vue?vue&type=script&lang=ts&"
export * from "./HomeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b6996",
  null
  
)

export default component.exports